import WordListItem from './WordListItem';
import type { Word } from '../../types/word.types';
import type { WordSearchData } from '../../services/wordSearchService';

interface WordSearchItemProps {
  searchData: WordSearchData;
}

function WordSearchItem({ searchData }: WordSearchItemProps) {
  // Aggregate all meanings from all data entries
  const allDefinitions = searchData.data.flatMap(entry => 
    entry.meanings.map(meaning => ({
      partOfSpeech: meaning.partOfSpeech,
      meaning: meaning.definitions[0]?.definition || '',
      example: meaning.definitions[0]?.example,
      synonyms: meaning.synonyms,
      antonyms: meaning.antonyms,
      definitions: meaning.definitions,
    }))
  );

  // Use the first entry for phonetic and other metadata
  const firstEntry = searchData.data[0];

  // Convert to Word type for display
  const wordItem: Word = {
    id: `preview-${searchData.word}`,
    word: searchData.word,
    definitions: allDefinitions,
    addedAt: new Date(),
    rating: 1,
    phonetic: firstEntry?.phonetic,
    phonetics: firstEntry?.phonetics,
    sourceUrls: firstEntry?.sourceUrls,
  };

  // Dummy handlers since preview mode doesn't use these
  const handleDelete = () => {};
  const handleRatingChange = () => {};

  return (
    <WordListItem
      word={wordItem}
      onDelete={handleDelete}
      onRatingChange={handleRatingChange}
      preview={true}
    />
  );
}

export default WordSearchItem;
